import { Button } from '@ui-components/actions/Button'
import { TightSectionContent } from '@ui-components/containers/TightSectionContent'
import { LeadText } from '@ui-components/typography/Typography'
import { useIntl } from 'react-intl'

export const NoExistingApplicationsView = ({ onNewApplicationSelect }: { onNewApplicationSelect: () => void }) => {
  const { formatMessage } = useIntl()
  return (
    <TightSectionContent>
      <LeadText>{formatMessage({ id: 'application-list-no-applications' })}</LeadText>
      <Button
        label={formatMessage({ id: 'application-list-new-application' })}
        variant={'primary'}
        color={'primary'}
        onClick={onNewApplicationSelect}
      />
    </TightSectionContent>
  )
}
